export enum RoutePath {
  Client = '/my-area',
  ClientAddresses = '/my-area/addresses',
  ClientPkg = '/my-area/packages',
  ClientPkgUnite = '/my-area/packages/unite',
  ClientPkgReturn = '/my-area/packages/return',
  ClientProfile = '/my-area/profile',
  ClientProfilePersonal = '/my-area/profile/personal',
  ClientProfileAddresses = '/my-area/profile/addresses',
  ClientProfileAffiliate = '/my-area/profile/affiliate',
  Login = '/login',
  ForgotPassword = '/forgot-password',
  ReceiptUpload = '/receipt-upload',
  PaymentShipping = '/payment/shipping',
  PaymentSummary = '/payment/summary',
  PaymentProcess = '/payment/process',
  Welcome = '/welcome',
}

export enum OfficeRoutePath {
  Coupon = '/office-coupon',
  Affiliate = '/office-affiliate',
  PkgLocation = '/office-location',
  PkgRequests = '/office-packageRequests',
  WarehouseArrivals = '/office-warehouse-arrivals',
  ScanMe = '/office-scan-me',
  PickupOrders = '/office-pickup-orders',
  PkgLookup = '/office-usa-package-lookup',
  PkgLookupsList = '/office-pkg-lookups-list',
  BarcodeGunShip = '/office-ship-barcode-gun',
  Shelfs = '/office/shelfs',
  AddNewPkg = '/office',
  Sticker = '/office-sticker/:pId/:name/:unit/:brand',
  Ship = '/office-ship',
  EditAndUpdate = '/office-e&u',
  CheckForm = '/office-checkForm',
  UserPage = '/office-userPage',
  ScanPickupOrders = '/office-scan-orders',
  DelayedPkgs = '/office/delayed-packages',
  Stats = '/office-stats',
  PopularBrandsItems = '/office-popular-brands-items',
  AdminSettings = '/office/admin/settings',
  AdminData = '/office/admin/data',
  AuditLog = '/office/admin/audit-log',
  ReceiptTextractTest = '/office/admin/receipt-textract-test',
  AffiliateManager = '/office/admin/affiliate-manager',
  ServiceReqs = '/office/service-reqs',
}
